/*
 * TEMPORARY — remove with outdatedBuildInterceptor.
 *
 * Shared by the interceptor, which shows it in the refresh toast and puts it on the failed
 * response, and by showErrorToast, which skips it so the refresh toast is the only one shown.
 */
const OUTDATED_BUILD_MESSAGE = 'Your change wasn\'t saved because TeamBuildr needs to be updated.';

export default OUTDATED_BUILD_MESSAGE;
